import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import { Button } from '@mui/material';
import Toggle from 'rsuite/Toggle';
import styles from './MyUsersPage.module.scss';
// import ListTable from '../../../../Components/ListTable/ListTable';
import { BackdropLoader } from '../../../Components/Loaders';
import ListTable from '../../../Components/ListTable/ListTable';
import ImageModal from '../../../Components/Modals/ImageModal/ImageModal';
import { modalActions } from '../../../Actions';
import { notificationServices } from '../../../Services';
import ImagesFinder from '../../../Components/ImagesFinder/ImagesFinder';
import userRolesAndPermissions from '../../../Services/userRolesAndPermissions.services';

const TABLE_COLUMNS = [
	{
		title: 'ID',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Username',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Display Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'App Store',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Email',
		config: {
			type: 'DATA',
		},
	},
];

const SPECIAL_COLUMNS = [
	{
		title: 'Edit User',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Active',
		config: {
			type: 'DATA',
		},
	},
];

const COLMAP = {
	ID: 'id',
	Username: 'username',
	'Display Name': 'displayName',
	'App Store': 'storeName',
	Email: 'email',
};

function MyUsersPermissionsPage({ userPermissions, createPath }) {
	const history = useHistory();
	const [isloading, setIsloading] = useState(false);
	const [usersData, setUsersData] = useState([]);
	const [selectedStore, setSelectedStore] = useState(null);

	const handleListFetch = async () => {
		setIsloading(true);
		try {
			const response = await userRolesAndPermissions.getUsersList();
			if (response?.statusCode === 200) {
				setSelectedStore(selectedStore);
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
				setUsersData(response?.data);
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message:
					'Unable to fetch users list, please connect with UY Team',
			});
		} finally {
			setIsloading(false);
		}
	};

	useEffect(() => {
		handleListFetch();
	}, []);

	const handleAddClick = () => {
		history.push(createPath);
	};

	const handleClick = (userId) => {
		history.push(`${createPath}?isEdit=true&id=${userId}`);
	};

	const handleIsActive = async (id, isActive) => {
		setIsloading(true);
		try {
			const response =
				await userRolesAndPermissions.changeUserActiveStatus({
					data: {
						userId: id,
						status: isActive,
					},
				});
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
				handleListFetch();
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('error', error);
		} finally {
			setIsloading(false);
		}
	};

	const SPECIAL_ITEMS = {
		'Edit User': (id) => {
			const user = usersData?.find((ele) => {
				return ele?.id === id;
			});
			return (
				<div className={styles.btn_container}>
					<Button
						fullWidth
						variant='outlined'
						color='primary'
						onClick={() => {
							handleClick(user?.id);
						}}
					>
						EDIT
					</Button>
				</div>
			);
		},
		Active: (id) => {
			const user = usersData?.find((ele) => {
				return ele?.id === id;
			});
			return (
				<div key={id} className={styles.btn_container}>
					<Toggle
						checked={user?.isActive}
						size='md'
						onChange={() => {
							handleIsActive(id, !user?.isActive);
						}}
					/>
				</div>
			);
		},
	};

	return (
		<div className={styles.root}>
			{/* <ListModal handleConfirm={iAmClicked} singleSelectable /> */}
			<BackdropLoader showProgress isLoading={isloading} />
			<ImageModal />
			<div className={styles.header}>
				<ImagesFinder
					pageLabel='My Users'
					onSubmit={handleListFetch}
					additionInfo={{
						showAdd: userPermissions.INTERNAL,
						// showAdd: false,
						addText: 'User',
						handleAddClick,
					}}
				/>
			</div>
			<div className={styles.list}>
				<ListTable
					colMap={COLMAP}
					columns={TABLE_COLUMNS}
					data={usersData}
					actions={[...SPECIAL_COLUMNS]}
					special={SPECIAL_ITEMS}
				/>
			</div>
		</div>
	);
}
const mapStateToProps = (state) => {
	const { userPermissions } = state.navigation;
	return {
		userPermissions,
	};
};

const mapDispatchToProps = {
	toggleModal: modalActions.toggleListModal,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(MyUsersPermissionsPage);
